import React, { useState, useRef, useEffect } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';
import GlobeItem from './GlobeItem';


const NavigationItem = ({
    links = [],
    contentLink = null,
    renderAddiontalLinks = true,
}) => {
    const topLinks = useSelector((state) => state.navigation.topLinkList);
    const marketLanguageItems = useSelector(
        (state) => state.navigation.marketLanguageItems
    );

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const body = document.querySelector(".js-body");
        if (isMenuOpen) {
            body.classList.add("disable-scroll--mobile");
        }
        else {
            body.classList.remove("disable-scroll--mobile");
        }
    }, [isMenuOpen]);


    const menuRef = useRef(null);
    const toggleMenu = (e, toggleIsMenuOpen) => {
        e.preventDefault();
        menuRef.current.classList.toggle('navbar__menu--show');
        if (toggleIsMenuOpen) {
            setIsMenuOpen(!isMenuOpen);
        }
    };

    const bannerTitle = contentLink && contentLink.bannerTitle ? contentLink.bannerTitle : null;
    const bannerImage = contentLink && contentLink.bannerImageUrl != null ? contentLink.bannerImageUrl : null;
    const bannerBannerHeaderTextcolor = contentLink && contentLink.bannerTitleColor != null ? contentLink.bannerTitleColor : '';
    const bannerBannerCTAColorSettings = contentLink && contentLink.bannerCTAColorSettings != null ? contentLink.bannerCTAColorSettings : '';
    const bannerCTAPlacement = contentLink && contentLink.bannerCTAPlacement != null ? contentLink.bannerCTAPlacement : '';
    const bannerLinkToPage = contentLink && contentLink.bannerLinkToPage != null ? contentLink.bannerLinkToPage : '';
    const bannerCTA = contentLink && contentLink.bannerCTA != null ? contentLink.bannerCTA : '';

    const boldColumnText = contentLink && contentLink.fontWeightBold ? 'font-bold' : 'font-regular';

    const showColumns = contentLink && contentLink.showMegaMenuColumns ? true : false;

    const showNavigationClass = showColumns ? 'navigation-row' : 'navigation-col';

    //url for column header
    const columnHeaderCategoryUrl = contentLink && contentLink.useCategoryLinkForColumnHeader ? contentLink.categoryLinkToColumnHeader : null;
    const columnHeaderPageUrl = contentLink && !contentLink.useCategoryLinkForColumnHeader ? contentLink.pageLinkToColumnHeader : null;

    let columnHeaderUrl = "#";

    if (columnHeaderCategoryUrl != null || columnHeaderPageUrl != null) {
        columnHeaderUrl = columnHeaderCategoryUrl != null ? columnHeaderCategoryUrl : columnHeaderPageUrl;
    }

    //url for banner
    const bannerCategoryUrl = contentLink && contentLink.useCategoryLinkForBanner ? contentLink.bannerLinkToCategory : null;
    const bannerPageUrl = contentLink && !contentLink.useCategoryLinkForBanner ? contentLink.bannerLinkToPage : null;

    let bannerUrl = "#";

    if (bannerCategoryUrl != null || bannerPageUrl != null) {
        bannerUrl = bannerCategoryUrl != null ? bannerCategoryUrl : bannerPageUrl;
    }

    const additionClassColumnHeader =
        contentLink && contentLink.attributesColumnHeader
            ? contentLink.attributesColumnHeader.cssValue
            : null;

    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0 || bannerTitle != null;
    const hideForMobile = (link) =>
        (!link.name || link.name === '') &&
        (!link.bannerImageUrl || link.bannerImageUrl === '');
    const hideSubSubLinksClass =
        contentLink && contentLink.showSubSubLinks ? "" : "hide-third-level";
    let navbarStateIcon = `navbar__icon${isMenuOpen ? '--close' : '--menu'}`;

    const handleLanguageChange = (e) => {
        const { value } = e.target;
        window.location = value;
    };

    document.addEventListener('DOMContentLoaded', function () {
        const navigationRows = document.querySelectorAll('.navigation-row');

        navigationRows.forEach(function (row) {
            const navigationBannerDesktop = row.querySelector('.navigation-banner-desktop');

            if (navigationBannerDesktop) {
                row.classList.add('contain-banner');
            }
        });
    });

    return (
        <>
            {!contentLink ? (
                <a
                    className={`navbar__link--block navbar__icon--menu ${navbarStateIcon} navbar__icon`}
                    onClick={(e) => toggleMenu(e, true)}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                ></a>
            ) : (
                <>
                    <a
                        className={`navbar__link ${columnHeaderUrl.length > 1 && 'column-header-url'} ${selectedClass} ${hasChildrenClass || ''} ${additionClass || ''} ${additionClassColumnHeader || ''} ${bannerTitle != null && 'hide-anchor-tag'}`}
                        href={contentLink.url ? contentLink.url : columnHeaderUrl}
                        onClick={(e) => {
                            if (contentLink.url && !contentLink.url.includes("#")) {
                                contentLink.url;
                            } else if (columnHeaderCategoryUrl != null) {
                                columnHeaderCategoryUrl
                            } else if (columnHeaderPageUrl != null) {
                                columnHeaderPageUrl
                            } else {
                                toggleMenu(e);
                            }
                        }}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                    {bannerTitle == null && links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon navbar__icon--open"
                            onClick={(e) => toggleMenu(e)}
                        ></i>
                    )}
                </>
            )}

            {bannerTitle != null && (
                <a href={bannerUrl ? bannerUrl : "#"}>
                    <div className="navigation-banner-mobile" >
                        <div className="navigation-banner-mobile-inner-wrapper">
                            <img src={bannerImage} className="column-banner-image" />
                            <h3 className={`banner-title-color-${bannerBannerHeaderTextcolor}`} >{bannerTitle}</h3>
                            {bannerCTA.length > 0 &&
                                <div className={`banner-cta banner-cta-colorsettings-${bannerBannerCTAColorSettings} banner-cta-placement-${bannerCTAPlacement}`}>
                                    <button className="banner-cta-button">{bannerCTA}</button>
                                </div>
                            }
                        </div>
                    </div>
                </a>
            )}

            {bannerTitle == null || bannerTitle == undefined ? (
                links.length > 0 &&
                <div className=
                    {`navbar__menu ${hideSubSubLinksClass}`}
                    ref={menuRef}>
                    <div className="navbar__menu-header">
                        {!contentLink ? (
                            <span
                                className="navbar__icon navbar__icon--close"
                                onClick={(e) => toggleMenu(e)}
                            ></span>
                        ) : (
                            <>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={(e) => toggleMenu(e)}

                                ></i>
                                <span
                                    className="navbar__title"
                                    onClick={(e) => toggleMenu(e)}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </>
                        )}
                    </div>
                    <ul className={`navbar__menu-links ${showNavigationClass}`}>
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li className={`navbar__item ${boldColumnText} ${hideForMobile(link) ? 'hide-for-small-only' : ''}`} key={index}>
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                renderAddiontalLinks={false}
                                            />
                                        </li>
                                    )
                            )}
                    </ul>
                </div>
            ) : (
                /*Banner content*/
                <a className="navigation-banner-desktop" href={bannerUrl ? bannerUrl : "#"}>
                    <div>
                        <img src={bannerImage} className="column-banner-image" />
                        <h3 className={`banner-title-color-${bannerBannerHeaderTextcolor}`} >{bannerTitle}</h3>
                        {bannerCTA.length > 0 &&
                            <div className={`banner-cta banner-cta-colorsettings-${bannerBannerCTAColorSettings} banner-cta-placement-${bannerCTAPlacement}`}>
                                <button className="banner-cta-button">{bannerCTA}</button>
                            </div>
                        }
                    </div>
                </a>
            )}
        </>
    );
};

export default NavigationItem;
